import { useEffect, useCallback } from 'react';
import json2mq from 'json2mq';
import useAssociativeArray from './useAssociativeArray';

const useMedia = mediaQueries => {
  const matchMedia = useCallback(
    key => {
      const query = mediaQueries[key];
      return window.matchMedia(
        typeof query === 'string' ? query : json2mq(query)
      );
    },
    [mediaQueries]
  );

  const [items, addItem] = useAssociativeArray({
    mediaQueries,
    matchMedia,
  });

  useEffect(() => {
    const disposeAll = Object.keys(mediaQueries).map(key => {
      const list = matchMedia(key);
      const listener = () => {
        if (list.matches) {
          addItem('device', key);
        }
        addItem(key, list.matches);
      };
      const dispose = () => list.removeListener(listener);

      list.addListener(listener);
      listener();

      return dispose;
    });

    return () => {
      disposeAll.forEach(dispose => dispose());
    };
  }, [addItem, matchMedia, mediaQueries]);

  return items;
};

export default useMedia;
